export const operatorCDNURL: Record<string, string> = {
    'hallabet-ng': "https://ng-hb.fast.ax",
    'acme': "https://bs.fast.ax"
}
